import React, { useState, useEffect, useMemo } from 'react'
import Router from './router'
import { Provider } from 'react-redux'
import GA from './common/GA'
import { start as GA4Start } from './common/GA4Tracker'
import store from './redux/store'
import { GlobalProvider } from './redux/globalStore'
import { UrlQueryParamsParse } from './common/globalFun'
import { ConfigProvider } from 'antd'

import './pages/css/reset.css'
import './App.css'

import { IntlProvider } from 'react-intl'
import enUS from './locales/en-US.json'
import jaJP from './locales/ja-JP.json'
import zhTW from './locales/zh-TW.json'

import a_enUS from 'antd/lib/locale/en_US'
import a_jaJP from 'antd/lib/locale/ja_JP'
import a_zhTW from 'antd/lib/locale/zh_TW'

const LANGUAGE = {
  'zh-hant': 'zh-TW',
  en: 'en-US',
  ja: 'ja-JP',
}

const NAVIGATOR_LANGUAGE = {
  zh: 'zh-TW',
  en: 'en-US',
  ja: 'ja-JP',
}

const messages = {
  'zh-TW': zhTW,
  'en-US': enUS,
  'ja-JP': jaJP,
}

const antdLocal = {
  'zh-TW': a_zhTW,
  'en-US': a_enUS,
  'ja-JP': a_jaJP,
}

const HTML_LANG = {
  'zh-TW': 'zh-TW',
  'en-US': 'en',
  'ja-JP': 'ja',
}

const App = () => {
  const [local, setLocal] = useState('')

  const getUrlLang = () => {
    const { search, hash } = window.location
    let urlQuery = search
    if (!urlQuery) {
      urlQuery = hash.slice(hash.indexOf('?'), hash.length)
    }
    const urlQuertParamsStr = urlQuery.replace(/^\?/, '')
    const queryParamsData = UrlQueryParamsParse(urlQuertParamsStr)
    if (queryParamsData && queryParamsData.lang) {
      return LANGUAGE[queryParamsData.lang] || ''
    }
    return ''
  }

  const getBrowserLang = () => {
    let lang = navigator.language || navigator.userLanguage
    lang = lang.substr(0, 2)
    return NAVIGATOR_LANGUAGE[lang] || LANGUAGE['ja']
  }

  useEffect(() => {
    window.react_intl_local = local
    document
      .getElementsByTagName('html')[0]
      .setAttribute('lang', HTML_LANG[local] || HTML_LANG['ja-JP'])
  }, [local])

  useEffect(() => {
    GA4Start()
    console.log('getBrowserLang()', getBrowserLang())
    setLocal(getUrlLang() || getBrowserLang())
  }, [])

  const globalState = useMemo(
    () => ({
      currentLanguage: local,
      languageKeys: Object.keys(messages),
      setLocalLanguage: (lang) => {
        setLocal(lang)
      },
    }),
    [setLocal, local]
  )

  return (
    <IntlProvider locale={local || 'en'} key={local} messages={messages[local]}>
      <Provider store={store}>
        <ConfigProvider locale={antdLocal[local]}>
          <GlobalProvider value={globalState}>
            {local && <Router />}
            <GA />
          </GlobalProvider>
        </ConfigProvider>
      </Provider>
    </IntlProvider>
  )
}

export default App
